function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 25H80C82.2091 25 84 26.7909 84 29V69H24V25Z",
  fill: "#D8DDEB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M88 12H138C140.209 12 142 13.7909 142 16V69H88V12Z",
  fill: "#D8DDEB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9 29C9 26.7909 10.7909 25 13 25H60C62.2091 25 64 26.7909 64 29V69H9V29Z",
  fill: "#EAEEF4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M73 16C73 13.7909 74.7909 12 77 12H124C126.209 12 128 13.7909 128 16V69H73V16Z",
  fill: "#EAEEF4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M133.397 1.68441C134.758 -0.56147 138.242 -0.56147 139.603 1.68441L149.538 18.0755C150.873 20.2783 149.158 23 146.434 23H126.566C123.843 23 122.127 20.2783 123.462 18.0755L133.397 1.68441ZM138.28 18.0435C138.28 18.956 137.483 19.6957 136.5 19.6957C135.517 19.6957 134.72 18.956 134.72 18.0435C134.72 17.1309 135.517 16.3912 136.5 16.3912C137.483 16.3912 138.28 17.1309 138.28 18.0435ZM136.5 4.8256C135.517 4.8256 134.72 5.56534 134.72 6.47784V11.4345C134.72 12.347 135.517 13.0868 136.5 13.0868C137.483 13.0868 138.28 12.347 138.28 11.4345V6.47784C138.28 5.56534 137.483 4.8256 136.5 4.8256Z",
  fill: "url(#paint0_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  y: 69,
  width: 150,
  height: 4,
  rx: 2,
  fill: "#F5F8FA"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 40,
  width: 24,
  height: 14,
  rx: 4,
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 43,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 32,
  y: 43,
  width: 4,
  height: 8,
  rx: 2,
  fill: "#D8DDEB"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 38,
  y: 43,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 42,
  y: 43,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 88,
  y: 34,
  width: 24,
  height: 14,
  rx: 4,
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 92,
  y: 37,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 96,
  y: 37,
  width: 4,
  height: 8,
  rx: 2,
  fill: "#D8DDEB"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 102,
  y: 37,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 106,
  y: 37,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 109.5,
  y1: 11.5,
  x2: 132.207,
  y2: 38.1566,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})));

function SvgPendingBarcodePackages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 73,
    viewBox: "0 0 150 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = React.forwardRef(SvgPendingBarcodePackages);
export default __webpack_public_path__ + "static/media/pending-barcode-packages.4e4bf48f.svg";
export { ForwardRef as ReactComponent };